/**
 * Quiet petrol chart palette for drill tiles.
 * Categorical series stay in one ink family; Signal Magenta is reserved for
 * primary trend/source accents elsewhere — not every bar.
 */
export const DRILL_CHART_COLORS = [
  'var(--ops-ink, #0E3A40)',
  'var(--petrol-ink-light, #14606B)',
  '#3d7a84',
  'var(--st-quiet, #6A8589)',
  '#8fa3a6',
  '#b0bfc1',
] as const;

export const DRILL_AXIS_TICK = {
  fill: 'var(--ink-3)',
  fontSize: 11,
} as const;

export const DRILL_GRID = 'var(--line)';

export function drillChartColor(i: number): string {
  return DRILL_CHART_COLORS[i % DRILL_CHART_COLORS.length];
}

/** Soft rank tint: strongest bucket slightly darker, rest fade. */
export function drillRankColor(i: number, total = 6): string {
  const t = Math.min(Math.max(i / Math.max(total - 1, 1), 0), 1);
  // Mix ops-ink → quiet so the set reads as one instrument, not a rainbow.
  if (t < 0.2) return 'var(--ops-ink, #0E3A40)';
  if (t < 0.45) return 'var(--petrol-ink-light, #14606B)';
  if (t < 0.7) return 'var(--st-quiet, #6A8589)';
  return '#9aadaf';
}
